import { render } from "./CreateChatbot.vue?vue&type=template&id=c3cfb836&scoped=true"
import script from "./CreateChatbot.vue?vue&type=script&lang=js"
export * from "./CreateChatbot.vue?vue&type=script&lang=js"

import "./CreateChatbot.vue?vue&type=style&index=0&id=c3cfb836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3cfb836"]])

export default __exports__